const { InnerBlocks } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { margin } = attributes;

  return (
    <div id="contact" title="#contact" className={`contactUs ${margin}`}>
      <div className="ContactUsCards">
        <InnerBlocks.Content />
      </div>
    </div>
  );
};

export default Save;
